// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashBoardBg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  overflow: auto;
  position: relative;
}
.dashBoardBg .ModalContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
  background: var(--Background);
  overflow: auto;
}
.dashBoardBg .ModalContainer .InteractivityModal {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.dashBoardBg .statusContainer {
  width: 100%;
  min-height: 7rem;
}
.dashBoardBg .statusContainer h1 {
  font-size: 1rem;
  color: var(--TextColor);
  margin-bottom: 0.3rem;
}
.dashBoardBg .statusContainer .LoadingContainer {
  width: 100%;
  height: 6rem;
  background: var(--Foreground);
  border-radius: 0.6rem;
}
.dashBoardBg .statusContainer .statusAnimate {
  width: 100%;
  white-space: nowrap;
  position: relative;
  overflow-x: hidden;
  scroll-behavior: smooth;
  mask-image: linear-gradient(to right, transparent 0%, var(--Background) 5%, var(--Background) 95%, transparent 100%);
}
.dashBoardBg .statusContainer .statusAnimate.removeMask {
  mask-image: none;
}
.dashBoardBg .statusContainer .statusAnimate:hover .animationDiv {
  animation-play-state: paused;
  width: 100%;
}
.dashBoardBg .statusContainer .statusAnimate:hover .animationDiv::-webkit-scrollbar {
  display: none;
}
.dashBoardBg .statusContainer .statusAnimate:hover .animationDiv::-ms-scrollbar {
  display: none;
}
.dashBoardBg .statusContainer .statusAnimate .leftBtn, .dashBoardBg .statusContainer .statusAnimate .rightBtn {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 5rem;
}
.dashBoardBg .statusContainer .statusAnimate .leftBtn button, .dashBoardBg .statusContainer .statusAnimate .rightBtn button {
  background-color: var(--Background);
  padding: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--TextColor);
}
.dashBoardBg .statusContainer .statusAnimate .leftBtn {
  left: 0;
}
.dashBoardBg .statusContainer .statusAnimate .rightBtn {
  right: 0;
}
.dashBoardBg .statusContainer .statusAnimate .animationDiv {
  display: inline-flex;
  animation: 40s slide infinite linear;
  scroll-behavior: smooth;
}
.dashBoardBg .statusContainer .statusAnimate .animationDivStop {
  animation-play-state: paused;
}
.dashBoardBg .statusContainer .statusAnimate .duplicateDiv {
  display: none;
}
.dashBoardBg .statusContainer .statusAnimate .scrollerDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;
}
.dashBoardBg .statusContainer .statusAnimate .scrollerDiv::-webkit-scrollbar {
  display: none;
}
.dashBoardBg .statusContainer .statusAnimate .statusBox {
  background-color: var(--Foreground);
  min-width: 12rem;
  max-width: 14rem;
  margin: 0rem 0.3rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.6rem;
  border-radius: 0.4rem;
}
.dashBoardBg .statusContainer .statusAnimate .statusBox p {
  font-size: 0.9rem;
  color: var(--TextColor);
  margin: 0;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}
.dashBoardBg .statusContainer .statusAnimate .statusBox .statusBar {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.dashBoardBg .statusContainer .statusAnimate .statusBox .statusBar div {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.dashBoardBg .statusContainer .statusAnimate .statusBox .statusBar div .status {
  margin: 0;
  color: var(--TextColor);
  opacity: 0.7;
  font-size: 0.6rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: default;
}
.dashBoardBg .statusContainer .statusAnimate .statusBox .statusBar div .Interact:hover {
  color: var(--AccentColor);
  cursor: pointer;
}
.dashBoardBg .statusContainer .statusAnimate .statusBox .statusBar div .pending {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background-color: var(--Pending);
}
.dashBoardBg .statusContainer .statusAnimate .statusBox .statusBar div .completed {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background-color: var(--Completed);
}
.dashBoardBg .statusContainer .statusAnimate .statusBox .SpinCont {
  flex: 1 1;
}
.dashBoardBg .statusCharts {
  flex: 1 1;
  width: 100%;
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: auto;
}
.dashBoardBg .statusCharts .noDataFound {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashBoardBg .statusCharts .chartsContainer {
  flex: 2 1 30rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding-bottom: 3rem;
  overflow: auto;
  mask-image: linear-gradient(to top, transparent, var(--Background) 10%);
}
.dashBoardBg .statusCharts .chartsContainer::-webkit-scrollbar {
  height: 0.3rem;
}
.dashBoardBg .statusCharts .chartsContainer .heading {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
}
.dashBoardBg .statusCharts .chartsContainer .heading .dropDownContainer {
  position: absolute;
  background-color: var(--Foreground);
  display: flex;
  flex-direction: column;
  right: 0;
  top: 70%;
  z-index: 2;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 4px 0 6px -1px rgba(0, 0, 0, 0.1), -4px 0 6px -1px rgba(0, 0, 0, 0.1);
}
.dashBoardBg .statusCharts .chartsContainer .heading .dropDownContainer p {
  padding: 0.3rem 0.6rem;
  color: var(--TextColor);
  width: 100%;
  text-align: center;
}
.dashBoardBg .statusCharts .chartsContainer .heading .dropDownContainer p:hover {
  background-color: var(--AccentColor);
  border-radius: 0.3rem;
  color: white;
}
.dashBoardBg .statusCharts .chartsContainer .heading h1 {
  font-size: 0.9rem;
  font-weight: 600;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--TextColor);
}
.dashBoardBg .statusCharts .chartsContainer .heading div {
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
  align-items: center;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  background-color: var(--Background);
}
.dashBoardBg .statusCharts .chartsContainer .heading div p {
  font-size: 0.7rem;
  color: var(--TextColor);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea {
  flex: 1 1;
  border: 1px solid var(--Stroke);
  border-radius: 0.4rem;
  overflow: hidden;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  align-items: center;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner {
  width: 100%;
  height: 100%;
  /* height: 65%; */
  padding-bottom: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex: 1 1;
  min-height: 6rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .duplicate::before {
  content: "";
  width: 0;
  height: 0;
  border-left: 0.4rem solid transparent;
  border-right: 0.4rem solid transparent;
  border-bottom: 1rem solid var(--Foreground);
  position: absolute;
  top: -0.3rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .rotator,
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .duplicate {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 4.5rem;
  height: 4.5rem;
  background-color: var(--Foreground);
  background-color: transparent;
  border-radius: 50%;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .rotator p,
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .duplicate p {
  color: var(--TextColor);
  text-align: center;
  text-transform: capitalize;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .rotator p:nth-child(1),
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .duplicate p:nth-child(1) {
  font-size: 1rem;
  font-weight: 600;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .rotator p:nth-child(2),
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieInner .duplicate p:nth-child(2) {
  font-size: 0.6rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer {
  width: 100%;
  /* height: 35%; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0rem 0.6rem;
  min-height: 5rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends {
  width: 90%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(45%, 1fr));
  row-gap: 0.3rem;
  column-gap: 0.3rem;
  position: relative;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p {
  color: var(--TextColor);
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  padding-left: 1rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p::before {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  position: absolute;
  top: 25%;
  left: 0;
  content: "";
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p:nth-child(1)::before {
  background-color: var(--Invitation);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p:nth-child(2)::before {
  background-color: var(--Accepted);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p:nth-child(3)::before {
  background-color: var(--Pending);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p:nth-child(4)::before {
  background-color: var(--Cancelled);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p:nth-child(5)::before {
  background-color: var(--Reinitiated);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p:nth-child(6)::before {
  background-color: var(--Inprogress);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .pieContainer .pieLegendContainer .pieLegends p:nth-child(7)::before {
  background-color: var(--Completed);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialInner {
  flex: 1 1;
  max-width: calc(100% - 10rem);
  min-width: 10rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends {
  width: min-content;
  padding-right: 0.3rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  justify-content: space-evenly;
  position: relative;
  gap: 0.3rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends .legendDetails {
  position: relative;
  padding-left: 0.6rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends .legendDetails::before {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  width: 0.3rem;
  height: 100%;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends .legendDetails:nth-child(1)::before {
  background-color: var(--Background);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends .legendDetails:nth-child(2)::before {
  background-color: var(--Completed);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends .legendDetails:nth-child(3)::before {
  background-color: var(--Cancelled);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends .legendDetails p {
  color: var(--TextColor);
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends .legendDetails p:nth-child(1) {
  font-size: 1rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashBoardBg .statusCharts .chartsContainer .chartArea .radialContainer .radialLegends .legendDetails p:nth-child(2) {
  font-size: 0.6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashBoardBg .statusCharts .chartsContainer .chartsTopContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.6rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .leftBar {
  flex: 0.45 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .leftBar .overview {
  width: 100%;
  height: 14.1rem;
  display: flex;
  flex-direction: column;
  background-color: var(--Foreground);
  border-radius: 0.4rem;
  padding: 0.5rem;
  gap: 0.5rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .leftBar .statusChart {
  width: 100%;
  height: 20.1rem;
  display: flex;
  flex-direction: column;
  background-color: var(--Foreground);
  border-radius: 0.4rem;
  padding: 0.5rem;
  gap: 0.5rem;
}
.dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .rightBar {
  width: 65%;
  flex: 0.55 1;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  align-items: center;
}
.dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .rightBar .amountSpent,
.dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .rightBar .packDetails {
  width: 100%;
  height: 17.1rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: var(--Foreground);
  border-radius: 0.4rem;
}
.dashBoardBg .statusCharts .chartsContainer .verticalBarContainer {
  width: 100%;
  min-height: 19rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: var(--Foreground);
  border-radius: 0.4rem;
}
.dashBoardBg .statusCharts .userCred {
  flex: 1 1 30rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--Foreground);
  border-radius: 0.4rem;
  padding: 0.6rem;
  overflow: auto;
  gap: 0.5rem;
}
.dashBoardBg .statusCharts .userCred .header {
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
}
.dashBoardBg .statusCharts .userCred .header div {
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
  align-items: center;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  background-color: var(--Background);
  position: relative;
  margin-right: 0.6rem;
  cursor: pointer;
}
.dashBoardBg .statusCharts .userCred .header div p {
  font-size: 0.7rem;
  color: var(--TextColor);
}
.dashBoardBg .statusCharts .userCred .header div .dropDownContainer {
  position: absolute;
  background-color: var(--Foreground);
  display: flex;
  flex-direction: column;
  right: 0%;
  top: 100%;
  z-index: 2;
  width: max-content;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 4px 0 6px -1px rgba(0, 0, 0, 0.1), -4px 0 6px -1px rgba(0, 0, 0, 0.1);
}
.dashBoardBg .statusCharts .userCred .header div .dropDownContainer p {
  cursor: pointer;
  padding: 0.3rem 0.6rem;
  color: var(--TextColor);
  width: 100%;
  text-align: center;
}
.dashBoardBg .statusCharts .userCred .header div .dropDownContainer p:hover {
  background-color: var(--AccentColor);
  border-radius: 0.3rem;
  color: white;
}
.dashBoardBg .statusCharts .userCred .header h1 {
  font-size: 1rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--TextColor);
  flex: 1 1;
}
.dashBoardBg .statusCharts .userCred .header .swapBtn {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--Background);
  width: 10rem;
  justify-content: space-between;
  padding: 0.2rem;
  border-radius: 0.3rem;
  cursor: pointer;
}
.dashBoardBg .statusCharts .userCred .header .swapBtn p {
  width: 50%;
  text-align: center;
  padding: 0.2rem 0.6rem;
  font-size: 0.8rem;
  color: var(--TextColor);
  opacity: 0.7;
  transition: all 0.4s ease;
}
.dashBoardBg .statusCharts .userCred .header .swapBtn .active {
  background-color: var(--Foreground);
  border-radius: 0.3rem;
  opacity: 1;
  transition: all 0.4s ease;
}
.dashBoardBg .statusCharts .userCred .credBody {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  gap: 0.3rem;
}
.dashBoardBg .statusCharts .userCred .credBody .candidateDetail {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0.375rem 0.5rem;
  align-items: center;
  border: 1px solid var(--Stroke);
  border-radius: 0.5rem;
}
.dashBoardBg .statusCharts .userCred .credBody .candidateDetail .DetailCont {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(5rem, 1fr));
  gap: 0.5rem;
}
.dashBoardBg .statusCharts .userCred .credBody .candidateDetail .DetailCont div {
  flex: 1 1 4rem;
}
.dashBoardBg .statusCharts .userCred .credBody .candidateDetail .DetailCont div p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dashBoardBg .statusCharts .userCred .credBody .candidateDetail .DetailCont div p:nth-child(1) {
  font-size: 0.625rem;
  color: #9b9b9b;
}
.dashBoardBg .statusCharts .userCred .credBody .candidateDetail .DetailCont div p:nth-child(2) {
  font-size: 0.75rem;
  color: var(--TextColor);
  padding-left: 0.25rem;
}
.dashBoardBg .statusCharts .userCred .credBody .candidateDetail button {
  background-color: var(--Invitation);
  border-radius: 0.4rem;
  padding: 0.3rem 0.8rem;
  color: var(--TextColor);
  outline: none;
  font-size: 0.875rem;
  text-transform: capitalize;
}
.dashBoardBg .statusCharts .userCred .pagination {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: var(--Foreground);
  padding: 0.3rem 1.25rem;
  justify-content: center;
}
.dashBoardBg .statusCharts .userCred .pagination button {
  padding: 0.18rem 0.3rem;
  border-radius: 0.3rem;
  color: var(--TextColor);
  font-size: 0.7rem;
}
.dashBoardBg .statusCharts .userCred .pagination .pageButton {
  background-color: var(--Background);
  color: var(--TextColor);
}
.dashBoardBg .statusCharts .userCred .pagination .pageButton.active {
  background-color: var(--AccentColor);
  color: white;
}
.dashBoardBg .statusCharts .userCred .pagination .pageButton:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}
.dashBoardBg .statusCharts .userCred .pagination .dataPerpage p {
  font-size: 0.7rem;
  color: var(--TextColor);
}
.dashBoardBg .statusCharts .userCred .pagination .dataPerpage select {
  border: 1px solid var(--AccentColor);
  border-radius: 0.2rem;
  color: var(--TextColor);
  background-color: var(--Foreground);
  font-size: 0.7rem;
}
.dashBoardBg .statusCharts .userCred .pagination .dataPerpage select option {
  font-size: 0.6rem;
  color: var(--TextColor);
}
.dashBoardBg .statusCharts .userCred .pagination div {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

@keyframes slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
@media (min-width: 950px) and (max-width: 1250px) {
  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .leftBar {
    flex-grow: 0.5;
    flex-shrink: 0.5;
  }
  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .rightBar {
    flex-grow: 0.5;
    flex-shrink: 0.5;
  }
}
@media (max-width: 950px) {
  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer {
    flex-direction: column;
  }
  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .leftBar {
    flex: 1 1;
  }
  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .rightBar {
    flex: 1 1;
    width: 100%;
  }
}
@media (max-width: 975px) {
  .dashBoardBg .statusCharts .chartsContainer {
    height: auto;
    mask-image: none;
    padding-bottom: 0;
  }
  .dashBoardBg .statusCharts .chartsContainer .verticalBarContainer {
    flex: 0 0;
    height: 25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/DashBoard/DashBoard.scss"],"names":[],"mappings":"AAAA;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAAF;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,cAAA;AACJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAEN;AACE;EACE,WAAA;EACA,gBAAA;AACJ;AAAI;EACE,eAAA;EACA,uBAAA;EACA,qBAAA;AAEN;AAAI;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;AAEN;AAAI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oHAAA;AAEN;AAKM;EACE,gBAAA;AAHR;AAKM;EACE,4BAAA;EACA,WAAA;AAHR;AAIQ;EACE,aAAA;AAFV;AAIQ;EACE,aAAA;AAFV;AAKM;EACE,kBAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAHR;AAMQ;EACE,mCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAJV;AAQM;EACE,OAAA;AANR;AAQM;EACE,QAAA;AANR;AAUM;EACE,oBAAA;EACA,oCAAA;EACA,uBAAA;AARR;AAWM;EACE,4BAAA;AATR;AAYM;EACE,aAAA;AAVR;AAaM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;AAXR;AAaQ;EACE,aAAA;AAXV;AAeM;EACE,mCAAA;EACA,gBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AAdR;AAeQ;EACE,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAbV;AAeQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAbV;AAcU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAZZ;AAaY;EACE,SAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAXd;AAaY;EACE,yBAAA;EACA,eAAA;AAXd;AAaY;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;AAXd;AAaY;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;AAXd;AAeQ;EACE,SAAA;AAbV;AAkBE;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAhBJ;AAiBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfN;AAiBI;EAEE,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;EACA,uEAAA;AAhBN;AAiBM;EACE,cAAA;AAfR;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AAfR;AAgBQ;EACE,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,oHAAA;AAdV;AAiBU;EACE,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAfZ;AAgBY;EACE,oCAAA;EACA,qBAAA;EACA,YAAA;AAdd;AAkBQ;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AAhBV;AAmBQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mCAAA;AAjBV;AAkBU;EACE,iBAAA;EACA,uBAAA;AAhBZ;AAqBM;EACE,SAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;AAnBR;AAoBQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AAlBV;AAmBU;EACE,WAAA;EACA,YAAA;EAIA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AApBZ;AAsBc;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,sCAAA;EACA,2CAAA;EAEA,kBAAA;EACA,YAAA;AArBhB;AAwBY;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mCAAA;EACA,6BAAA;EACA,kBAAA;AAtBd;AAuBc;;EACE,uBAAA;EACA,kBAAA;EACA,0BAAA;AApBhB;AAqBgB;;EACE,eAAA;EACA,gBAAA;AAlBlB;AAoBgB;;EACE,iBAAA;AAjBlB;AAsBU;EAQE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AA3BZ;AA4BY;EACE,UAAA;EACA,YAAA;EAEA,aAAA;EACA,yDAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AA3Bd;AA4Bc;EACE,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AA1BhB;AA2BgB;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;AAzBlB;AA2BgB;EACE,mCAAA;AAzBlB;AA2BgB;EACE,iCAAA;AAzBlB;AA2BgB;EACE,gCAAA;AAzBlB;AA2BgB;EACE,kCAAA;AAzBlB;AA2BgB;EACE,oCAAA;AAzBlB;AA2BgB;EACE,mCAAA;AAzBlB;AA2BgB;EACE,kCAAA;AAzBlB;AA+BQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA7BV;AA8BU;EACE,SAAA;EACA,6BAAA;EACA,gBAAA;AA5BZ;AA8BU;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;AA5BZ;AA6BY;EACE,kBAAA;EACA,oBAAA;AA3Bd;AA4Bc;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EAEA,YAAA;AA3BhB;AA8Bc;EACE,mCAAA;AA5BhB;AA+Bc;EACE,kCAAA;AA7BhB;AAgCc;EACE,kCAAA;AA9BhB;AAgCc;EACE,uBAAA;AA9BhB;AA+BgB;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7BlB;AA+BgB;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7BlB;AAoCM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAlCR;AAuCQ;EAEE,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAvCV;AAyCU;EACE,WAAA;EAEA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AAxCZ;AA2CU;EACE,WAAA;EAEA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AA1CZ;AA8CQ;EACE,UAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AA7CV;AA+CU;;EAEE,WAAA;EAEA,eAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,qBAAA;AA9CZ;AAmDM;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,qBAAA;AAjDR;AAoDI;EAEE,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AAnDN;AAoDM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAlDR;AAoDQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AAlDV;AAmDU;EACE,iBAAA;EACA,uBAAA;AAjDZ;AAmDU;EACE,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,oHAAA;AAjDZ;AAoDY;EACE,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAlDd;AAmDc;EACE,oCAAA;EACA,qBAAA;EACA,YAAA;AAjDhB;AAsDQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AApDV;AAsDQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AApDV;AAqDU;EACE,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;AAnDZ;AAqDU;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;AAnDZ;AAwDM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAtDR;AA0DQ;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qBAAA;AAxDV;AAyDU;EACE,SAAA;EACA,aAAA;EACA,0DAAA;EACA,WAAA;AAvDZ;AAwDY;EACE,cAAA;AAtDd;AAuDc;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;AArDhB;AAsDgB;EACE,mBAAA;EACA,cAAA;AApDlB;AAsDgB;EACE,kBAAA;EACA,uBAAA;EACA,qBAAA;AApDlB;AAyDU;EACE,mCAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;AAvDZ;AA2DM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,uBAAA;EACA,uBAAA;AAzDR;AA0DQ;EAEE,uBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;AAzDV;AA2DQ;EACE,mCAAA;EACA,uBAAA;AAzDV;AA0DU;EACE,oCAAA;EACA,YAAA;AAxDZ;AA0DU;EACE,mBAAA;EACA,YAAA;AAxDZ;AA6DU;EACE,iBAAA;EACA,uBAAA;AA3DZ;AA6DU;EACE,oCAAA;EACA,qBAAA;EACA,uBAAA;EACA,mCAAA;EACA,iBAAA;AA3DZ;AA4DY;EACE,iBAAA;EACA,uBAAA;AA1Dd;AA+DQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA7DV;;AAuEA;EACE;IACE,wBAAA;EApEF;EAsEA;IACE,4BAAA;EApEF;AACF;AAsEA;EACE;IACE,cAAA;IACA,gBAAA;EApEF;EAsEA;IACE,cAAA;IACA,gBAAA;EApEF;AACF;AAuEA;EACE;IACE,sBAAA;EArEF;EAuEA;IACE,SAAA;EArEF;EAuEA;IACE,SAAA;IACA,WAAA;EArEF;AACF;AAwEA;EAGM;IACE,YAAA;IACA,gBAAA;IACA,iBAAA;EAxEN;EAyEM;IACE,SAAA;IACA,aAAA;EAvER;AACF","sourcesContent":[".dashBoardBg {\n  // width: 100%;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  overflow: auto;\n  position: relative;\n  .ModalContainer {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 3;\n    background: var(--Background);\n    overflow: auto;\n    .InteractivityModal {\n      width: 100%;\n      height: 100%;\n      overflow: auto;\n    }\n  }\n  .statusContainer {\n    width: 100%;\n    min-height: 7rem;\n    h1 {\n      font-size: 1rem;\n      color: var(--TextColor);\n      margin-bottom: 0.3rem;\n    }\n    .LoadingContainer {\n      width: 100%;\n      height: 6rem;\n      background: var(--Foreground);\n      border-radius: 0.6rem;\n    }\n    .statusAnimate {\n      width: 100%;\n      white-space: nowrap;\n      position: relative;\n      overflow-x: hidden;\n      scroll-behavior: smooth;\n      mask-image: linear-gradient(\n        to right,\n        transparent 0%,\n        var(--Background) 5%,\n        var(--Background) 95%,\n        transparent 100%\n      );\n      &.removeMask{\n        mask-image: none;\n      }\n      &:hover .animationDiv {\n        animation-play-state: paused;\n        width: 100%;\n        &::-webkit-scrollbar {\n          display: none;\n        }\n        &::-ms-scrollbar {\n          display: none;\n        }\n      }\n      .leftBtn, .rightBtn{\n        position: absolute;\n        top: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n        width: 5rem;\n\n        // background-color: var(--Foreground);\n        button{\n          background-color: var(--Background);\n          padding: .75rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border-radius: 50%;\n          font-size: 1.25rem;\n          font-weight: 600;\n          color: var(--TextColor);\n          \n        }\n      }\n      .leftBtn{\n        left: 0;\n      }\n      .rightBtn{\n        right: 0;\n      }\n      \n\n      .animationDiv {\n        display: inline-flex;\n        animation: 40s slide infinite linear;\n        scroll-behavior: smooth;\n        // scroll-snap-type: x mandatory;\n      }\n      .animationDivStop {\n        animation-play-state: paused;\n      }\n\n      .duplicateDiv {\n        display: none;\n      }\n\n      .scrollerDiv {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        width: 100%;\n        overflow-x: auto;\n        scroll-behavior: smooth;\n        // scroll-snap-type: inline mandatory;\n        &::-webkit-scrollbar {\n          display: none;\n        }\n      }\n\n      .statusBox {\n        background-color: var(--Foreground);\n        min-width: 12rem;\n        max-width: 14rem;\n        // max-width: 14rem;\n        margin: 0rem 0.3rem;\n        display: flex;\n        flex-direction: column;\n        gap: 0.4rem;\n        padding: 0.6rem;\n        border-radius: 0.4rem;\n        p {\n          font-size: 0.9rem;\n          color: var(--TextColor);\n          margin: 0;\n          font-weight: 700;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          text-wrap: nowrap;\n        }\n        .statusBar {\n          display: flex;\n          flex-direction: column;\n          gap: 0.2rem;\n          div {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 0.5rem;\n            .status {\n              margin: 0;\n              color: var(--TextColor);\n              opacity: 0.7;\n              font-size: 0.6rem;\n              font-weight: 600;\n              display: flex;\n              align-items: center;\n              cursor: default;\n            }\n            .Interact:hover {\n              color: var(--AccentColor);\n              cursor: pointer;\n            }\n            .pending {\n              width: 0.6rem;\n              height: 0.6rem;\n              border-radius: 50%;\n              background-color: var(--Pending);\n            }\n            .completed {\n              width: 0.6rem;\n              height: 0.6rem;\n              border-radius: 50%;\n              background-color: var(--Completed);\n            }\n          }\n        }\n        .SpinCont {\n          flex: 1;\n        }\n      }\n    }\n  }\n  .statusCharts {\n    flex: 1;\n    width: 100%;\n    display: flex;\n    gap: 0.5rem;\n    flex-direction: row;\n    flex-wrap: wrap;\n    overflow: auto;\n    .noDataFound {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .chartsContainer {\n      // width: 55%;\n      flex: 2 35rem 30rem;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 0.6rem;\n      padding-bottom: 3rem;\n      overflow: auto;\n      mask-image: linear-gradient(to top, transparent, var(--Background) 10%);\n      &::-webkit-scrollbar {\n        height: 0.3rem;\n      }\n      .heading {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n        align-items: center;\n        justify-content: space-between;\n        cursor: pointer;\n        position: relative;\n        .dropDownContainer {\n          position: absolute;\n          background-color: var(--Foreground);\n          display: flex;\n          flex-direction: column;\n          right: 0;\n          top: 70%;\n          z-index: 2;\n          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n            4px 0 6px -1px rgba(0, 0, 0, 0.1),\n            -4px 0 6px -1px rgba(0, 0, 0, 0.1);\n          p {\n            padding: 0.3rem 0.6rem;\n            color: var(--TextColor);\n            width: 100%;\n            text-align: center;\n            &:hover {\n              background-color: var(--AccentColor);\n              border-radius: 0.3rem;\n              color: white;\n            }\n          }\n        }\n        h1 {\n          font-size: 0.9rem;\n          font-weight: 600;\n          text-wrap: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          color: var(--TextColor);\n        }\n\n        div {\n          display: flex;\n          flex-direction: row;\n          gap: 0.3rem;\n          align-items: center;\n          padding: 0.2rem 0.4rem;\n          border-radius: 0.3rem;\n          background-color: var(--Background);\n          p {\n            font-size: 0.7rem;\n            color: var(--TextColor);\n          }\n        }\n      }\n\n      .chartArea {\n        flex: 1;\n        border: 1px solid var(--Stroke);\n        border-radius: 0.4rem;\n        overflow: hidden;\n        .pieContainer {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          gap: 0.3rem;\n          align-items: center;\n          .pieInner {\n            width: 100%;\n            height: 100%;\n            // padding-bottom: .6rem;\n            // position: relative;\n            // width: 100%;\n            /* height: 65%; */\n            padding-bottom: 0.6rem;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            position: relative;\n            flex: 1;\n            min-height: 6rem;\n            .duplicate {\n              &::before {\n                content: \"\";\n                width: 0;\n                height: 0;\n                border-left: 0.4rem solid transparent;\n                border-right: 0.4rem solid transparent;\n                border-bottom: 1rem solid var(--Foreground);\n                // border-bottom: 0.6rem solid black;\n                position: absolute;\n                top: -0.3rem;\n              }\n            }\n            .rotator,\n            .duplicate {\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n              justify-content: center;\n              position: absolute;\n              width: 4.5rem;\n              height: 4.5rem;\n              background-color: var(--Foreground);\n              background-color: transparent;\n              border-radius: 50%;\n              p {\n                color: var(--TextColor);\n                text-align: center;\n                text-transform: capitalize;\n                &:nth-child(1) {\n                  font-size: 1rem;\n                  font-weight: 600;\n                }\n                &:nth-child(2) {\n                  font-size: 0.6rem;\n                }\n              }\n            }\n          }\n          .pieLegendContainer {\n            // width: 100%;\n            // height: 35%;\n            // display: flex;\n            // flex-direction: row;\n            // align-items: center;\n            // justify-content: center;\n            // padding: 0rem .6rem;\n            width: 100%;\n            /* height: 35%; */\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: center;\n            padding: 0rem 0.6rem;\n            min-height: 5rem;\n            .pieLegends {\n              width: 90%;\n              height: 100%;\n              // padding: .6rem 1rem;\n              display: grid;\n              grid-template-columns: repeat(auto-fit, minmax(45%, 1fr));\n              row-gap: 0.3rem;\n              column-gap: 0.3rem;\n              position: relative;\n              p {\n                color: var(--TextColor);\n                font-size: 0.8rem;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                position: relative;\n                padding-left: 1rem;\n                &::before {\n                  width: 0.6rem;\n                  height: 0.6rem;\n                  border-radius: 50%;\n                  position: absolute;\n                  top: 25%;\n                  left: 0;\n                  content: \"\";\n                }\n                &:nth-child(1)::before {\n                  background-color: var(--Invitation);\n                }\n                &:nth-child(2)::before {\n                  background-color: var(--Accepted);\n                }\n                &:nth-child(3)::before {\n                  background-color: var(--Pending);\n                }\n                &:nth-child(4)::before {\n                  background-color: var(--Cancelled);\n                }\n                &:nth-child(5)::before {\n                  background-color: var(--Reinitiated);\n                }\n                &:nth-child(6)::before {\n                  background-color: var(--Inprogress);\n                }\n                &:nth-child(7)::before {\n                  background-color: var(--Completed);\n                }\n              }\n            }\n          }\n        }\n        .radialContainer {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          flex-direction: row;\n          gap: 0.3rem;\n          .radialInner {\n            flex: 1;\n            max-width: calc(100% - 10rem);\n            min-width: 10rem;\n          }\n          .radialLegends {\n            width: min-content;\n            padding-right: 0.3rem;\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            align-items: flex-start;\n            justify-content: space-evenly;\n            position: relative;\n            gap: 0.3rem;\n            .legendDetails {\n              position: relative;\n              padding-left: 0.6rem;\n              &::before {\n                position: absolute;\n                top: 0;\n                left: 0;\n                content: \"\";\n                width: 0.3rem;\n                // background-color: var(--Background);\n                height: 100%;\n                // z-index: 10;\n              }\n              &:nth-child(1)::before {\n                background-color: var(--Background);\n              }\n\n              &:nth-child(2)::before {\n                background-color: var(--Completed);\n              }\n\n              &:nth-child(3)::before {\n                background-color: var(--Cancelled);\n              }\n              p {\n                color: var(--TextColor);\n                &:nth-child(1) {\n                  font-size: 1rem;\n                  font-weight: 600;\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                }\n                &:nth-child(2) {\n                  font-size: 0.6rem;\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                }\n              }\n            }\n          }\n        }\n      }\n      .chartsTopContainer {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        gap: 0.6rem;\n        // flex-wrap: wrap;\n        // overflow-x: hidden;\n        // overflow-y: auto;\n\n        .leftBar {\n          // width: 45%;\n          flex: 0.45;\n          // height: 100%;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 0.6rem;\n          // overflow: auto;\n          .overview {\n            width: 100%;\n            // height: 40%;\n            height: 14.1rem;\n            display: flex;\n            flex-direction: column;\n            background-color: var(--Foreground);\n            border-radius: 0.4rem;\n            padding: 0.5rem;\n            gap: 0.5rem;\n            // overflow: auto;\n          }\n          .statusChart {\n            width: 100%;\n            // height: 60%;\n            height: 20.1rem;\n            display: flex;\n            flex-direction: column;\n            background-color: var(--Foreground);\n            border-radius: 0.4rem;\n            padding: 0.5rem;\n            gap: 0.5rem;\n            // overflow: auto;\n          }\n        }\n        .rightBar {\n          width: 65%;\n          // height: 100%;\n          flex: 0.55;\n          display: flex;\n          flex-direction: column;\n          gap: 0.6rem;\n          align-items: center;\n          // overflow: auto;\n          .amountSpent,\n          .packDetails {\n            width: 100%;\n            // height: 50%;\n            height: 17.1rem;\n            padding: 0.5rem;\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            background-color: var(--Foreground);\n            border-radius: 0.4rem;\n            // overflow: auto;\n          }\n        }\n      }\n      .verticalBarContainer {\n        width: 100%;\n        min-height: 19rem;\n        padding: 0.5rem;\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n        background-color: var(--Foreground);\n        border-radius: 0.4rem;\n      }\n    }\n    .userCred {\n      // width: 45%;\n      flex: 1 40rem 30rem;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      background-color: var(--Foreground);\n      border-radius: 0.4rem;\n      padding: 0.6rem;\n      overflow: auto;\n      gap: 0.5rem;\n      .header {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        position: relative;\n        align-items: center;\n        // justify-content: space-between;\n        div {\n          display: flex;\n          flex-direction: row;\n          gap: 0.3rem;\n          align-items: center;\n          padding: 0.2rem 0.4rem;\n          border-radius: 0.3rem;\n          background-color: var(--Background);\n          position: relative;\n          margin-right: 0.6rem;\n          cursor: pointer;\n          p {\n            font-size: 0.7rem;\n            color: var(--TextColor);\n          }\n          .dropDownContainer {\n            position: absolute;\n            background-color: var(--Foreground);\n            display: flex;\n            flex-direction: column;\n            right: 0%;\n            top: 100%;\n            z-index: 2;\n            width: max-content;\n            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n              4px 0 6px -1px rgba(0, 0, 0, 0.1),\n              -4px 0 6px -1px rgba(0, 0, 0, 0.1);\n            p {\n              cursor: pointer;\n              padding: 0.3rem 0.6rem;\n              color: var(--TextColor);\n              width: 100%;\n              text-align: center;\n              &:hover {\n                background-color: var(--AccentColor);\n                border-radius: 0.3rem;\n                color: white;\n              }\n            }\n          }\n        }\n        h1 {\n          font-size: 1rem;\n          font-weight: 600;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          color: var(--TextColor);\n          flex: 1;\n        }\n        .swapBtn {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          background-color: var(--Background);\n          width: 10rem;\n          justify-content: space-between;\n          padding: 0.2rem;\n          border-radius: 0.3rem;\n          cursor: pointer;\n          p {\n            width: 50%;\n            text-align: center;\n            padding: 0.2rem 0.6rem;\n            font-size: 0.8rem;\n            color: var(--TextColor);\n            opacity: 0.7;\n            transition: all 0.4s ease;\n          }\n          .active {\n            background-color: var(--Foreground);\n            border-radius: 0.3rem;\n            opacity: 1;\n            transition: all 0.4s ease;\n            // transition: transform 1s ease-out;\n          }\n        }\n      }\n      .credBody {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        overflow: auto;\n        gap: 0.3rem;\n        // &::-webkit-scrollbar{\n        //     width: .2rem;\n        // }\n        .candidateDetail {\n          width: 100%;\n          display: flex;\n          flex-direction: row;\n          gap: 1rem;\n          padding: 0.375rem 0.5rem;\n          align-items: center;\n          border: 1px solid var(--Stroke);\n          border-radius: 0.5rem;\n          .DetailCont {\n            flex: 1;\n            display: grid;\n            grid-template-columns: repeat(auto-fit, minmax(5rem, 1fr));\n            gap: 0.5rem;\n            div {\n              flex: 1 6rem 4rem;\n              p {\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                &:nth-child(1) {\n                  font-size: 0.625rem;\n                  color: #9b9b9b;\n                }\n                &:nth-child(2) {\n                  font-size: 0.75rem;\n                  color: var(--TextColor);\n                  padding-left: 0.25rem;\n                }\n              }\n            }\n          }\n          button {\n            background-color: var(--Invitation);\n            border-radius: 0.4rem;\n            padding: 0.3rem 0.8rem;\n            color: var(--TextColor);\n            outline: none;\n            font-size: 0.875rem;\n            text-transform: capitalize;\n          }\n        }\n      }\n      .pagination {\n        display: flex;\n        align-items: center;\n        gap: 0.6rem;\n        background: var(--Foreground);\n        padding: 0.3rem 1.25rem;\n        justify-content: center;\n        button {\n          // padding: 3px 3px 0px 3px;\n          padding: 0.18rem 0.3rem;\n          border-radius: 0.3rem;\n          color: var(--TextColor);\n          font-size: 0.7rem;\n        }\n        .pageButton {\n          background-color: var(--Background);\n          color: var(--TextColor);\n          &.active {\n            background-color: var(--AccentColor);\n            color: white;\n          }\n          &:disabled {\n            cursor: not-allowed;\n            opacity: 0.8;\n          }\n        }\n\n        .dataPerpage {\n          p {\n            font-size: 0.7rem;\n            color: var(--TextColor);\n          }\n          select {\n            border: 1px solid var(--AccentColor);\n            border-radius: 0.2rem;\n            color: var(--TextColor);\n            background-color: var(--Foreground);\n            font-size: 0.7rem;\n            option {\n              font-size: 0.6rem;\n              color: var(--TextColor);\n            }\n          }\n        }\n\n        div {\n          display: flex;\n          align-items: center;\n          gap: 0.6rem;\n          // p{\n          //     font-size: 13px;\n          // }\n        }\n      }\n    }\n  }\n}\n\n@keyframes slide {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-100%);\n  }\n}\n@media (min-width: 950px) and (max-width: 1250px) {\n  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .leftBar {\n    flex-grow: 0.5;\n    flex-shrink: 0.5;\n  }\n  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .rightBar {\n    flex-grow: 0.5;\n    flex-shrink: 0.5;\n  }\n}\n\n@media (max-width: 950px) {\n  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer {\n    flex-direction: column;\n  }\n  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .leftBar {\n    flex: 1;\n  }\n  .dashBoardBg .statusCharts .chartsContainer .chartsTopContainer .rightBar {\n    flex: 1;\n    width: 100%;\n  }\n}\n\n@media (max-width: 975px) {\n  .dashBoardBg {\n    .statusCharts {\n      .chartsContainer {\n        height: auto;\n        mask-image: none;\n        padding-bottom: 0;\n        .verticalBarContainer {\n          flex: 0 0;\n          height: 25rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
